/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { auth } from '@atlaskit/outbound-auth-flow-client/auth'` instead.
 */
export { auth } from './auth';
/**
 * @deprecated Use `import { AuthError } from '@atlaskit/outbound-auth-flow-client/error'` instead.
 */
export { AuthError } from './error';
